"use client"
import { useRef } from "react";
import Image from "next/image";
import { useTranslation } from "@/hooks/translationContext";

export default function HeroScrollDown() {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    const featuredVenues = document.getElementById("featured-venues");
    const isMobile = window.innerWidth < 768;

    let scrollTarget = 0;

    if (featuredVenues) {
      const offset = isMobile ? 0 : -120;
      scrollTarget = featuredVenues.getBoundingClientRect().top + window.scrollY + offset;
    } else {
      scrollTarget = isMobile ? window.innerHeight + 60 : window.innerHeight + 30;
    }

    window.scrollTo({
      top: scrollTarget,
      behavior: "smooth"
    });
  };

  return (
    <div>
      <div className="flex justify-center items-center">
        <div className="cursor-pointer w-11 h-11 p-0.5 bg-slate-800 bg-opacity-20 rounded-[22px] flex-col justify-center items-center gap-2 inline-flex">
          <div
            ref={ref}
            onClick={() => handleScroll()}
            className="p-2 bg-white rounded-[26px] shadow justify-center items-center gap-1 inline-flex"
          >
            <Image
              loader={({ src }) => src}
              sizes="24px"
              unoptimized
              src="/scroll-down.webp"
              alt={t("homepage-scroll-down-alt")}
              title={t("homepage-scroll-down-alt")}
              width={24}
              height={24}
              style={{
                maxWidth: "100%",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
